import { useMutation } from '@tanstack/react-query';
import { updateBrand, IUpdateBrandResponse } from 'src/api/updateBrand';
import { useSnackbar, SnackbarStatus } from '@weareopenr/component-library';
import { useUserTracking } from '../useUserTracking/useUserTracking';

export const useUpdateBrand = (onMutationSuccess: () => void) => {
  const { showSnackbar } = useSnackbar();
  const { captureException } = useUserTracking();

  return useMutation(
    (params: { id: string; name?: string; file?: File | null }) =>
      updateBrand(params.id, params.name, params.file),
    {
      onSuccess: (data: IUpdateBrandResponse) => {
        showSnackbar({
          message: `${data.name} has successfully been edited.`,
          status: SnackbarStatus.SUCCESS,
        });
        onMutationSuccess();
      },
      onError: (error, req) => {
        showSnackbar({
          message: `Unable to edit ${req.name}`,
          status: SnackbarStatus.ERROR,
        });
        captureException(error);
      },
    },
  );
};
